import { render, staticRenderFns } from "./PtiPlanPaciente.vue?vue&type=template&id=79f0a937"
import script from "./PtiPlanPaciente.vue?vue&type=script&lang=js"
export * from "./PtiPlanPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports